/** CoStar.Api.WalkScore.TravelTimePolygonMode */
export var TravelTimePolygonMode;
(function (TravelTimePolygonMode) {
    TravelTimePolygonMode[TravelTimePolygonMode["None"] = 0] = "None";
    TravelTimePolygonMode[TravelTimePolygonMode["Walk"] = 1] = "Walk";
    TravelTimePolygonMode[TravelTimePolygonMode["Bike"] = 2] = "Bike";
    TravelTimePolygonMode[TravelTimePolygonMode["Drive"] = 3] = "Drive";
    TravelTimePolygonMode[TravelTimePolygonMode["Transit"] = 4] = "Transit";
})(TravelTimePolygonMode || (TravelTimePolygonMode = {}));
